// extracted by mini-css-extract-plugin
export default {"containerResultsS":"styles_containerResultsS__M0KTy"};